export const RATING_TYPE = {
    sirating: 1,
    siscoring: 2,
    gendergap: 3
}


